module.exports = __webpack_public_path__ + "img/support.249df1bd.png";